  <template>
  <div>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               ref="crud"
               v-model="form"
               :search.sync="query"
               :permission="permissionList"
               :before-open="beforeOpen"
               @row-del="rowDel"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="refreshChange"
               @on-load="onLoad">
      <!-- 自定义列表多功能栏 -->
      <table-column-set :THIS_TO_PARENT="this"
                        slot="menuRight" />
      <template slot="menuLeft">
        <el-button type="danger"
                   size="small"
                   icon="el-icon-delete"
                   v-if="permission.role_delete"
                   @click="handleDelete">删 除
        </el-button>
        <el-button size="small"
                   icon="el-icon-setting"
                   @click="handleRole"
                   v-if="userInfo.role_name.includes('admin')"
                   plain>权限设置
        </el-button>
      </template>
    </avue-crud>

    <!-- 角色权限配置 -->
    <dialog-reset :visible.sync="box"
                  width="30%"
                  height="75vh"
                  top="3vh"
                  slotShow="true"
                  title="角色权限配置">
      <el-tabs type="border-card">
        <el-tab-pane label="菜单权限">
          <el-tree :data="menuGrantList"
                   show-checkbox
                   node-key="id"
                   ref="treeMenu"
                   :default-checked-keys="menuTreeObj"
                   :props="props">
          </el-tree>
        </el-tab-pane>
        <el-tab-pane label="数据权限">
          <el-tree :data="dataScopeGrantList"
                   show-checkbox
                   node-key="id"
                   ref="treeDataScope"
                   :default-checked-keys="dataScopeTreeObj"
                   :props="props">
          </el-tree>
        </el-tab-pane>
        <el-tab-pane label="接口权限">
          <el-tree :data="apiScopeGrantList"
                   show-checkbox
                   node-key="id"
                   ref="treeApiScope"
                   :default-checked-keys="apiScopeTreeObj"
                   :props="props">
          </el-tree>
        </el-tab-pane>
      </el-tabs>

      <span slot="dialog_footer"
            class="dialog-footer">
        <el-button type="primary"
                   icon="el-icon-circle-plus-outline"
                   v-loading="submitloading"
                   @click="submit">提 交</el-button>
        <el-button v-loading="submitloading"
                   icon="el-icon-circle-close"
                   @click="box = false">关 闭</el-button>
      </span>
    </dialog-reset>
  </div>
</template>

<script>
import {
  add,
  getList,
  getRole,
  getRoleTreeById,
  grant,
  grantTree,
  remove,
  update,
} from '@/api/system/role'
import { mapGetters } from 'vuex'
import website from '@/config/website'
import crudmixins from '@/basic-common/mixins/crudmixins.js'
import { removePercent } from '@/util/util'
const mixin = new crudmixins({})
export default {
  mixins: [mixin],
  data() {
    return {
      submitloading: false,
      form: {},
      query: { termType: '1', clientId: 'client_enterprise' },
      box: false,
      props: {
        label: 'title',
        value: 'key',
      },
      menuGrantList: [],
      dataScopeGrantList: [],
      apiScopeGrantList: [],
      apiGrantList: [],
      menuTreeObj: [],
      dataScopeTreeObj: [],
      apiScopeTreeObj: [],
      selectionList: [],
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      option: {
        ...this.$store.state.publicOption,
        tip: false,
        simplePage: true,
        searchShow: true,
        searchMenuSpan: 8,
        tree: true,
        // border: true,
        index: true,
        selection: true,
        viewBtn: true,
        dialogWidth: 900,
        dialogClickModal: false,
        column: [
          {
            label: '角色名称',
            prop: 'roleName',
            search: true,
            maxlength: 40,
            width: 200,
            overHidden: true,
            align: "left",
            rules: [
              {
                required: true,
                message: '请输入角色名称',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '所属租户',
            prop: 'tenantId',
            type: 'tree',
            dicUrl: '/api/blade-system/tenant/select',
            addDisplay: false,
            editDisplay: false,
            viewDisplay: website.tenantMode,
            props: {
              label: 'tenantName',
              value: 'tenantId',
            },
            hide: !website.tenantMode,
            search: website.tenantMode,
            rules: [
              {
                required: true,
                message: '请输入所属租户',
                trigger: 'click',
              },
            ],
          },
          {
            label: '角色别名',
            prop: 'roleAlias',
            search: true,
            maxlength: 40,
            overHidden: true,
            rules: [
              {
                required: true,
                message: '请输入角色别名',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '上级角色',
            prop: 'parentId',
            dicData: [],
            type: 'tree',
            hide: true,
            props: {
              label: 'title',
            },
            rules: [
              {
                required: false,
                message: '请选择上级角色',
                trigger: 'click',
              },
            ],
          },
          {
            label: '角色排序',
            prop: 'sort',
            type: 'number',
            max: 200,
            rules: [
              {
                required: true,
                message: '请输入角色排序',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '终端类型',
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=term_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            prop: 'termType',
            search: true,
            searchValue: '1',
            slot: true,
            rules: [
              {
                required: true,
                message: '请选择终端类型',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '用户类别',
            type: 'select',
            dicUrl: '/api/blade-system/client/list',
            props: {
              label: 'clientName',
              value: 'clientId',
            },
            dicFormatter: (res) => {
              return res.data.records
            },
            slot: true,
            search: true,
            prop: 'clientId',
            rules: [
              {
                required: true,
                message: '请选择用户类别',
                trigger: 'blur',
              },
            ],
          },
        ],
      },
      data: [],
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.role_add, false),
        viewBtn: this.vaildData(this.permission.role_view, false),
        delBtn: this.vaildData(this.permission.role_delete, false),
        editBtn: this.vaildData(this.permission.role_edit, false),
      }
    },
    ids() {
      let ids = []
      this.selectionList.forEach((ele) => {
        ids.push(ele.id)
      })
      return ids.join(',')
    },
    idsArray() {
      let ids = []
      this.selectionList.forEach((ele) => {
        ids.push(ele.id)
      })
      return ids
    },
  },
  methods: {
    initData(roleId) {
      getRoleTreeById(roleId).then((res) => {
        const column = this.findObject(this.option.column, 'parentId')
        column.dicData = res.data.data
      })
    },
    submit() {
      const menuList = this.$refs.treeMenu.getCheckedKeys()
      const dataScopeList = this.$refs.treeDataScope.getCheckedKeys()
      const apiScopeList = this.$refs.treeApiScope.getCheckedKeys()
      this.submitloading = true
      grant(this.idsArray, menuList, dataScopeList, apiScopeList).then(() => {
        this.box = false
        this.$message({
          type: 'success',
          message: '操作成功!',
        })
        this.onLoad(this.page)
      }).finally(() => {
        this.submitloading = false
      })
    },
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功!',
          })
          done()
        },
        (error) => {
          window.console.log(error)
          loading()
        }
      )
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功!',
          })
          done()
        },
        (error) => {
          window.console.log(error)
          loading()
        }
      )
    },
    rowDel(row) {
      this.$confirm_danger('删除')
        .then(() => {
          return remove(row.id)
        })
        .then(() => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功!',
          })
        })
    },

    searchReset() {
      this.query = { termType: '1', clientId: 'client_enterprise' }
      this.onLoad(this.page)
    },
    searchChange(params, done) {
      this.query = params
      this.page.currentPage = 1
      this.onLoad(this.page, params)
      done()
    },
    selectionChange(list) {
      this.selectionList = list
    },
    selectionClear() {
      this.selectionList = []
      this.$refs.crud.toggleSelection()
    },
    beforeOpen(done, type) {
      if (type === 'add') {
        this.form.termType = this.query.termType
        this.form.clientId = this.query.clientId
      }
      if (['add', 'edit'].includes(type)) {
        this.initData(this.form.id)
      }
      done()
    },
    handleRole() {
      if (this.selectionList.length !== 1) {
        this.$message.warning('只能选择一条数据')
        return
      }
      this.menuTreeObj = []
      this.dataScopeTreeObj = []
      this.apiScopeTreeObj = []
      const { clientId, termType } = this.selectionList[0]
      grantTree({ clientId, termType }).then((res) => {
        this.menuGrantList = res.data.data.menu
        this.dataScopeGrantList = res.data.data.dataScope
        this.apiScopeGrantList = res.data.data.apiScope
        getRole(this.ids).then((res) => {
          this.menuTreeObj = res.data.data.menu
          this.dataScopeTreeObj = res.data.data.dataScope
          this.apiScopeTreeObj = res.data.data.apiScope
          this.box = true
        })
      })
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据')
        return
      }
      this.$confirm_danger('删除')
        .then(() => {
          return remove(this.ids)
        })
        .then(() => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功!',
          })
          this.$refs.crud.toggleSelection()
        })
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize
    },
    refreshChange() {
      const params = {
        clientId: this.query.clientId,
        roleAlias: this.query.roleAlias,
        roleName: this.query.roleName,
        tenantId: this.query.tenantId,
        termType: this.query.termType,
      }
      this.onLoad(this.page, params)
    },
    syncTableLayout() {
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.$refs.crud && this.$refs.crud.doLayout) {
            this.$refs.crud.doLayout()
          }
        }, 0)
      })
    },
    onLoad(page, params = {}) {
      this.loading = true
      let queryData = this.removeNullAttribute(Object.assign(params, this.query))
      // 去除参数%
       queryData = removePercent(this.deepClone(queryData))
      getList(page.currentPage, page.pageSize, queryData).then(
        (res) => {
          this.data = res.data.data
          this.loading = false
          this.selectionClear()
          this.syncTableLayout()
        }
      )
    },
  },
}
</script>
